import React from 'react';

import Circle from 'components/circle';
import RichText from 'components/rich-text';

import { ReactComponent as Illustration } from 'svg/about.svg';

import './style.css';

const AboutInfo = () => {
  return (
    <section className="about-info" id="about-info">
      <Circle
        className="about-circle"
        width="400px"
        angle={0}
        distance={16}
        blur={16}
      />
      <Illustration className="about-illustration" />
      <RichText className="about-info-content">
        <h3>About Us</h3>
        <p>
          We are experienced business entrepreneurs who have created Tweak+ in
          order to give other businesses an outsider’s perspective of their
          current situations. As former business owners ourselves, our purpose
          and our passion is to help others who might feel stuck. After selling
          our companies to investment funds, we can now dedicate ourselves to
          helping other entrepreneurs regain momentum.
        </p>
        <p>
          Our method is unique, and differs from traditional consulting—rather
          than costly and time-intensive assessments and meetings, Tweak+ is a
          quick view that allows us to provide you with the most effective and
          tangible solutions to launch your business or keep it on track.
        </p>
        <p>
          <b>Together, we will find your Tweak.</b>
        </p>
      </RichText>
      <div id="about-info-end-circuit" className="target" />
    </section>
  );
};

export default AboutInfo;
